import React from 'react'
import PropTypes from 'prop-types'
import { keyframes } from '@emotion/react'
import { Box, Button, CircularProgress } from '@mui/material'
import { BRAND, GRADIENT, RADIUS, SURFACE, TEXT } from '../../theme/tokens'

const rotateBorder = keyframes`
  0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%}
`

/**
 * The AI tools' run button: an animated brand-gradient border (orange and
 * Fun Blue) around a card-coloured pill with primary text, in both themes.
 */
const GlowButton = ({ children, onClick, disabled, loading, startIcon }) => (
    <Box
        sx={{
            position: 'relative',
            display: 'inline-flex',
            borderRadius: `${RADIUS.pill}px`,
            p: '2px',
            background: GRADIENT.glow,
            backgroundSize: '400% 400%',
            animation: disabled ? 'none' : `${rotateBorder} 3s ease infinite`,
            opacity: disabled ? 0.45 : 1,
        }}
    >
        <Button
            onClick={onClick}
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            startIcon={
                loading ? (
                    <CircularProgress size={16} sx={{ color: BRAND.orange }} />
                ) : (
                    startIcon
                )
            }
            sx={{
                borderRadius: `${RADIUS.pill}px`,
                background: SURFACE.card,
                color: TEXT.primary,
                px: 4,
                py: 1.2,
                typography: 'body1',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                '&:hover': { background: SURFACE.cardRaised },
                // Disabled while loading too, when the label says what is
                // running, so it stays readable (AA), not disabled-dim.
                '&.Mui-disabled': {
                    color: TEXT.secondary,
                    background: SURFACE.card,
                },
            }}
        >
            {children}
        </Button>
    </Box>
)

GlowButton.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    startIcon: PropTypes.node,
}

export default GlowButton
